import "jquery-colorbox";
import { URLASSOLUTO } from "./variables";

const colorbox = $(document).ready(function () {
    $(".colorbox").colorbox({ maxWidth: "90%", maxHeight: "90%" });
    $(".colorboxtube").colorbox({
        iframe: true,
        innerWidth: "90%",
        innerHeight: "90%",
        maxWidth: 1200,
        maxHeight: 700,
    });
    //$(".privacypop").colorbox({iframe: true, href: URLASSOLUTO + "/privacy-policy-iframe.html", innerWidth: '95%', innerHeight: 450 });
    $(".newsletterpop").colorbox({
        iframe: true,
        href: URLASSOLUTO + "/newsletter-policy-iframe.html",
        innerWidth: "95%",
        innerHeight: 450,
    });
    $(".cookiepop").colorbox({
        iframe: true,
        href: URLASSOLUTO + "/cookie-policy-iframe.html",
        innerWidth: "95%",
        innerHeight: 450,
    });
    $(".condizionivenditapop").colorbox({
        iframe: true,
        href: URLASSOLUTO + "/pdf/uploads/condizioni-di-vendita-attuali.pdf",
        innerWidth: "95%",
        innerHeight: 450,
    });
});

export { colorbox as default };
